import React from 'react'

const ErrorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path d="M16 10.333V17.333" stroke="#6B600D" strokeWidth="2.53" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M28.1076 11.4404V20.5603C28.1076 22.0537 27.3076 23.4404 26.0142 24.2004L18.0942 28.7737C16.8009 29.5204 15.2009 29.5204 13.8942 28.7737L5.9742 24.2004C4.68087 23.4537 3.88086 22.067 3.88086 20.5603V11.4404C3.88086 9.94704 4.68087 8.56032 5.9742 7.80032L13.8942 3.22699C15.1875 2.48033 16.7876 2.48033 18.0942 3.22699L26.0142 7.80032C27.3076 8.56032 28.1076 9.9337 28.1076 11.4404Z" stroke="#6B600D" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16 21.5996V21.7329" stroke="#6B600D" strokeWidth="2.53" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default ErrorIcon